<template>
  <div class="full_page_grey">
    <div
      :class="['status_title_con_' + orderInfo.AuditState, 'status_title_con']"
    >
      {{ orderInfo.State }}
    </div>

    <div class="order_info_box">
      <div class="f-bt order_info_item">
        <p class="c-grey-6">商户名称</p>
        <p>{{ orderInfo.TenantName }}</p>
      </div>
      <template v-if="orderType == 'tenant'">
        <div class="f-bt order_info_item">
          <p class="c-grey-6">门店名称</p>
          <p>{{ orderInfo.VpnName }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">联系人</p>
          <p>{{ orderInfo.Contact }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">联系电话</p>
          <p>{{ orderInfo.PhoneNumber }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">证书编号</p>
          <p>{{ orderInfo.CertCode }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">注册时间</p>
          <p>{{ orderInfo.Creation }}</p>
        </div>
        <!-- <div class="f-bt order_info_item" v-if="orderInfo.AuditState === 2">
          <p class="c-grey-6">拒绝原因</p>
          <p>{{ orderInfo.MerchantName }}</p>
        </div> -->
      </template>
      <template v-if="orderType == 'vpn'">
        <div class="f-bt order_info_item">
          <p class="c-grey-6">门店名称</p>
          <p>{{ orderInfo.VpnName }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">经营模式</p>
          <p>{{ orderInfo.BusinessMode }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">营业状态</p>
          <p>{{ orderInfo.IsEnabled ? "正常" : "停业" }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">需要微信端</p>
          <p>{{ orderInfo.IsShelf ? "是" : "否" }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">创建时间</p>
          <p>{{ orderInfo.Creation }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">门店地址</p>
          <p>{{ orderInfo.AddressDescription }}</p>
        </div>
        <!-- <div class="f-bt order_info_item" v-if="orderInfo.AuditState === 2">
          <p class="c-grey-6">拒绝原因</p>
          <p>{{ orderInfo.MerchantName }}</p>
        </div> -->
      </template>
      <template v-if="orderType == 'equip'">
        <div class="f-bt order_info_item">
          <p class="c-grey-6">设备码</p>
          <p>{{ orderInfo.DeviceCode }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">激活码</p>
          <p>{{ orderInfo.UserCode }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">终端名称</p>
          <p>{{ orderInfo.ClientId }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">操作人</p>
          <p>{{ orderInfo.IdentityName }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">申请时间</p>
          <p>{{ orderInfo.CreationTimeTxt }}</p>
        </div>
        <div class="f-bt order_info_item">
          <p class="c-grey-6">过期时间</p>
          <p>{{ orderInfo.ExpirationTxt }}</p>
        </div>
      </template>
    </div>
    <!-- 门店/商户待审核 -->
    <gBottomBtnGroup v-if="orderType !== 'equip' && orderInfo.AuditState != 1">
      <div
        class="c-theme c-bg-theme-opacity c-f-1 c-block c-f-ar"
        @click="handleAuth(2)"
      >
        拒绝
      </div>
      <div
        class="c-f-1 c-block c-bg-theme c-f-ar c-white"
        @click="handleAuth(1)"
      >
        通过
      </div>
    </gBottomBtnGroup>
    <!-- 设备未激活时 -->
    <gBottomBtnGroup
      v-if="orderType == 'equip' && orderInfo.IsAuthorized == null"
    >
      <div
        class="c-f-1 c-block c-bg-theme c-f-ar c-white"
        @click="handleActive"
      >
        激活
      </div>
    </gBottomBtnGroup>
    <van-popup v-model="showReason" round closeable>
      <div class="input_remark_con">
        <p class="m-tb-20">拒绝原因</p>
        <van-field
          v-model="refuseReason"
          rows="4"
          autosize
          label=""
          type="textarea"
          maxlength="100"
          placeholder="请填写拒绝原因"
        />
        <van-button
          class="m-tb-20"
          color="#333"
          round
          block
          @click="handleSubmitReason"
          >确定</van-button
        >
      </div>
    </van-popup>
    <van-popup
      class="tenant_list_con"
      round
      v-model="showSelectTenantModal"
      position="bottom"
      :close-on-click-overlay="false"
    >
      <div class="cartTitle">
        <span> 请选择设备所属商户 </span>
        <span
          ><van-icon
            size="22"
            color="#999"
            name="close"
            @click="handleCloseVpnPop"
        /></span>
      </div>
      <div>
        <van-search
          v-model="merchantKey"
          show-action
          placeholder="请输入商户名称/营业执照编号进行搜索"
          @search="onSearch"
          @clear="onSearch"
        >
          <template #action>
            <div
              :style="{
                color: 'var(--tc)',
              }"
              @click="onSearch"
            >
              搜索
            </div>
          </template>
        </van-search>
      </div>
      <ul class="vpn_list_ul">
        <li
          v-for="item in vpnList"
          :key="item.Id"
          :class="item.Id == vpnInfo.Id ? 'active' : ''"
          @click="handleSelectVpn(item)"
        >
          <img
            class="radio_icon"
            :src="item.Id == vpnInfo.Id ? activeIcon : inactiveIcon"
            alt=""
          />
          <div class="vpn_right_con">
            {{ item.Name }}
          </div>
        </li>
      </ul>
      <div class="submit_btn_con">
        <van-button color="var(--tc)" round block @click="handleSubmitTenant"
          >确定</van-button
        >
        <!-- <p class="dark-btn" @click="placeOrder"
      v-if="keyBindMode !== 'ManualInputByWaiter' || handCode">{{ wechatPointPayMode === 'CyBillWithPad' ? '呼叫服务员' : '提交订单' }}</p> -->
      </div>
    </van-popup>
  </div>
</template>

<script>
/**
 * id: 订单状态
 * 0: 待审核
 * 1: 已通过
 * 2: 已拒绝
 */
import {
  authMerchant,
  authVpn,
  activeEquip,
  getAllMerchants,
} from "@/api/equip";
import { handleLocalStorage } from "@/utils";
import { Dialog } from "vant";

export default {
  name: "OrderDetail",
  props: {},
  data() {
    return {
      orderId: this.$route.query.id,
      orderType: "tenant",
      orderInfo: {},
      showReason: false,
      refuseReason: "",
      vpnInfo: { Name: "", Id: null },
      vpnList: [],
      merchantKey: "",
      activeIcon: require("@/assets/radio/radio-active-2.png"),
      inactiveIcon: require("@/assets/radio/radio-unactive-2.png"),
      showSelectTenantModal: false,
    };
  },
  created() {
    this.orderType = this.$route.query.type;
    const authInfoData = handleLocalStorage.get("authInfo");
    this.orderInfo = authInfoData;
    if (this.orderType == "equip") {
      this.handleGetMerchantList();
    }
    // this.getDrawList();
  },
  mounted() {},
  methods: {
    onSearch() {
      this.handleGetMerchantList();
    },
    handleGetMerchantList() {
      getAllMerchants({ Key: this.merchantKey })
        .then((res) => {
          this.vpnList = res;
        })
        .catch(() => {});
    },
    handleAuth(type) {
      Dialog.confirm({
        title: "提醒",
        message: "确认" + (type == 1 ? "通过" : "拒绝") + "吗？",
        cancelButtonText: "否",
        confirmButtonText: "是",
      })
        .then(() => {
          const requestUrl =
            this.orderType == "tenant" ? authMerchant : authVpn;
          let params =
            this.orderType == "tenant"
              ? { Id: this.orderInfo.Id, AuditState: type }
              : { VpnId: this.orderInfo.VpnId, AuditStateId: type };

          requestUrl(params)
            .then((res) => {
              this.$toast("操作成功");
              this.$router.replace({
                name:
                  this.orderType == "tenant"
                    ? "TenantOrderList"
                    : "VpnOrderList",
              });
            })
            .catch(() => {});
        })
        .catch(() => {
          // on cancel
        });
    },
    // handleRefuse() {
    //   this.showReason = true;
    // },
    handleSubmitReason() {
      this.showReason = false;
    },
    handleActive() {
      this.showSelectTenantModal = true;
    },

    handleSelectVpn(item) {
      this.vpnInfo = {
        Name: item.Name,
        // code: item.SaaSCode,
        Id: item.Id,
      };
    },
    handleSubmitTenant() {
      if (!this.vpnInfo.Id) {
        return this.$toast("请先选择商户");
      }
      Dialog.confirm({
        title: "激活提醒",
        message: "确认激活该设备吗？",
        cancelButtonText: "否",
        confirmButtonText: "是",
      })
        .then(() => {
          activeEquip({
            userCode: this.orderInfo.UserCode,
            tenantId: this.vpnInfo.Id,
            tenantName: this.vpnInfo.Name,
          })
            .then((res) => {
              this.showSelectTenantModal = false;
              this.$toast("操作成功");
              this.$router.replace({
                name: "EquipOrderList",
              });
            })
            .catch(() => {});
        })
        .catch(() => {
          // on cancel
        });
    },
    handleCloseVpnPop() {
      this.showSelectTenantModal = false;
    },
  },
};
</script>
<style scoped lang="scss">
.status_title_con {
  padding: 20px 30px;
  background: #e6ffe6;
  font-size: 28px;
  &.status_title_con_0 {
    background: #fce8e8;
  }
  &.status_title_con_2 {
    background: #bababa;
  }
}
.order_info_box {
  background: #ffffff;
  margin: 24px 32px;
  box-shadow: 0px 2px 0px 0px rgba(194, 194, 194, 0.5);
  border-radius: 12px;
  padding: 20px;
  .order_info_item {
    align-items: start;
    font-size: 26px;
    color: #333;
    margin-bottom: 16px;
    p:first-child {
      flex-shrink: 0;
      margin-right: 10px;
    }
  }
}
.input_remark_con {
  padding: 24px;
  width: 80vw;
}

.tenant_list_con {
  .cartTitle {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    height: 90px;
    font-size: 28px;
    color: #333;
    font-weight: bold;
  }

  .vpn_list_ul {
    margin: 24px;
    min-height: 20vh;
    max-height: 50vh;
    overflow-y: auto;
    li {
      padding: 20px 30px;
      border-radius: 16px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      .radio_icon {
        width: 26px;
        margin-right: 35px;
        flex-shrink: 0;
      }
      .vpn_right_con {
        flex: 1;
        font-size: 28px;
        font-weight: bold;
        color: #333;
      }
    }
  }
  .submit_btn_con {
    margin: 0 24px 30px;
  }
}
</style>
